import { redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

import { sessionHasPermission, type Permission } from '@/lib/permissions';
import { useAuth } from '@/store/auth';

// beforeLoad des routes : sans la permission (une seule suffit si tableau), retour au tableau de bord.
// Masquage côté console uniquement : l'API reste seule juge.
export const requirePermission = (perm: Permission | Permission[]) => {
  const user = useAuth.getState().session?.user;
  const perms = Array.isArray(perm) ? perm : [perm];
  if (perms.some((p) => sessionHasPermission(user, p))) return;
  // id fixe : un seul toast même si plusieurs routes imbriquées refusent
  toast.error('Accès refusé', { id: 'access-denied' });
  throw redirect({ to: '/dashboard' });
};
